export default __webpack_public_path__ + "static/media/ExcellentSmiley.f79f3b4a.svg";